import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineLeased";

const url = "/api/machines/machineLeased";

export const machineLeasedLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Machine Leased",
    url,
  }
);
